import vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from '../locale/en.json';
import twLocale from '../locale/tw.json';
import zhHant from 'vuetify/es5/locale/zh-Hant';
import en from 'vuetify/es5/locale/en';

const prefix_list = JSON.parse(JSON.stringify(enLocale.field_prefix));
const suffix_list = JSON.parse(JSON.stringify(enLocale.field_suffix));

class VueI18nEx extends VueI18n{

  tfd(p_field){
    let prefix_text = '';
    for(const em_i in prefix_list){
      if(!p_field.includes(em_i))
        continue;

      p_field = p_field.replace(em_i, '');
      prefix_text = prefix_text + this.t(`field_prefix.${em_i}`);
    }

    let suffix_text = '';
    for(const em_i in suffix_list){
      if(!p_field.includes(em_i))
        continue;

      p_field = p_field.replace(em_i, '');
      suffix_text = suffix_text + this.t(`field_suffix.${em_i}`);
    }
    let middle_text = (0 == p_field.length ? '' : this.t(`fields.${p_field}`));
    return prefix_text + middle_text + suffix_text;
  }
}

vue.use(VueI18nEx);

const messages = {
  en: {
    ...enLocale,
    ...en,
  },
  tw: {
    ...twLocale,
    ...zhHant,
  },
};

const language = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
// Create VueI18nEx instance with options
let i18n = new VueI18nEx({
  locale: language, // set locale
  messages, // set locale messages
  silentTranslationWarn: true,
});

export default i18n;
